module.exports = __webpack_public_path__ + "fonts/Clash-Regular.079308f.woff2";